import { createSlice, createAsyncThunk, isAllOf } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import httpService from "../../common/http.service";
// import { act } from "react";

export const appLoginUser = createAsyncThunk(
  "appUser/appLoginUser",
  async (params) => {
    try {
      const { email, password, navigate } = params;

      const response = await httpService.post(
        "/admin/signin",
        { email, password } 
      );

      if (response.data) {
        response.data.navigate = navigate;
      }
      return response.data;
    } catch (error) {
      toast.error(error?.message);
      throw error;
    }
  }
);

export const appUserSlice = createSlice({
  name: "User",
  initialState: {
    user: "",
    userType: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(isAllOf(appLoginUser.fulfilled), (state, action) => {
      state.user = action.payload?.data;

      const userPermissions =
        action.payload?.data?.user?.permissions || [];

      const permissionNames = userPermissions.map(
        (permission) => permission.name
      );

      state.userType = permissionNames;

      if (action?.payload?.data?.token) {
        localStorage.setItem(
          "token",
          action?.payload?.data?.token
        );

        localStorage.setItem(
          "user",
          JSON.stringify(action?.payload?.data)
        );

        localStorage.setItem(
          "permissions",
          permissionNames.join(",")
        );

        action.payload.navigate("/users");
      }
    });
  },
});


export default appUserSlice.reducer;
